module.exports = __webpack_public_path__ + "img/8a18c6a9174b069987f30b694612847a.png";